<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <b-card
          style="background: transparent !important"
          class="card-diagnostic"
        >
          <template #header>
            <strong class="mb-0">Detalle de la investigación</strong>
          </template>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <b-row>
              <b-col cols="6" class="mb-4">
                <Select
                  label="¿Enfermedad Investigada?"
                  name="disease_investigated"
                  v-model="formData.disease_investigated"
                  @onSelect="onSelectInvestigated"
                  :options="optionsSick"
                  :value="formData.disease_investigated"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <UploadFile
                  title="Adjunta aquí el archivo de la investigación"
                  titleDocumento="Investigación"
                  @uploadFile="uploadFile1"
                  :id="'file-diag-2'"
                  :required="true"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file1"
                  v-if="isInvestigated"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <Select
                  label="Notificación a la EPS"
                  name="eps_notification"
                  v-model="formData.eps_notification"
                  @onSelect="onSelectNotification"
                  v-if="isInvestigated"
                  :options="optionsNotification"
                  :value="formData.eps_notification"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <UploadFile
                  title="Adjunta aquí el archivo formato unico de enfermedad laboral (FUREL)"
                  titleDocumento="FUREL"
                  @uploadFile="uploadFile2"
                  :id="'file-diag-3'"
                  :required="true"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file2"
                  v-if="isInvestigated"
                />
              </b-col>
              <b-col cols="6" class="mb-4">
                <Textarea
                  label="Observaciones de la investigación"
                  name="research_observations"
                  :rows="'3'"
                  :value="formData.research_observations"
                  :disabled="isEdit || isBusy"
                  @input="
                    (event) => (formData.research_observations = event.target.value)
                  "
                  v-if="isInvestigated"
                />
              </b-col>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" class="mb-4">
                    <UploadFile
                      title="Adjunta aquí el archivo notificación al ministerio"
                      titleDocumento="Notificación al ministerio"
                      @uploadFile="uploadFile3"
                      :required="true"
                      :id="'file-diag-4'"
                      :isBusy="isBusy"
                      :isEdit="isEdit"
                      :document="file3"
                      v-if="isInvestigated"
                    />
                  </b-col>
                  <b-col cols="12" class="">
                    <UploadFile
                      title="Adjunta el archivo notificación a la EPS"
                      titleDocumento="Notificación a la EPS"
                      @uploadFile="uploadFile4"
                      :id="'file-diag-5'"
                      :required="true"
                      :isBusy="isBusy"
                      :isEdit="isEdit"
                      :document="file4"
                      v-if="isNotification"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UploadFile from "./UploadFile";
import useInputs from "@/components/general/Inputs";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

const { Select, Textarea } = useInputs();
export default {
  components: {
    Select,
    Textarea,
    UploadFile,
    OverlayButton,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      optionsSick: [
        {
          id: "1",
          name: "Si",
        },
        {
          id: "2",
          name: "No",
        },
      ],
      optionsNotification: [
        {
          id: "1",
          name: "Si",
        },
        {
          id: "2",
          name: "No",
        },
      ],
      formData: {
        disease_investigated: null,
        eps_notification: null,
        research_observations: null,
        investigation_file: null,
        furel_file: null,
        ministry_notification_file: null,
        eps_notification_file: null,
      },
      isInvestigated: false,
      isNotification: false,
      file1: null,
      file2: null,
      file3: null,
      file4: null,
    };
  },
  watch: {
    formData: {
      handler() {
        this.$emit("changeForm", this.formData);
      },
      deep: true,
    },
    record() {
      const me = this;
      if (me.record) me.fillData();
    }
  },
  methods: {
    uploadFile1(file) {
      const me = this;
      me.formData.investigation_file = file;
    },
    uploadFile2(file) {
      const me = this;
      me.formData.furel_file = file;
    },
    uploadFile3(file) {
      const me = this;
      me.formData.ministry_notification_file = file;
    },
    uploadFile4(file) {
      const me = this;
      me.formData.eps_notification_file = file;
    },
    onSelectNotification(value) {
      const me = this;
      me.isNotification = value?.id === "1";
      if (me.isNotification) me.formData.eps_notification_file = null;
    },
    onSelectInvestigated(value) {
      const me = this;
      me.isInvestigated = value?.id === "1";
      if (!me.isInvestigated) {
        me.isNotification = false;
        me.formData.eps_notification = null;
        me.formData.research_observations = null;
        me.formData.investigation_file = null;
        me.formData.furel_file = null;
        me.formData.ministry_notification_file = null;
        me.formData.eps_notification_file = null;
        me.$emit("changeForm", me.formData);
      }
    },
    fillData() {
      const me = this;
      const investigated = me.record?.disease_investigated ? "1" : "2";
      const investigatedValue = me.optionsSick.find(
        (item) => item.id === investigated
      );
      me.onSelectInvestigated(investigatedValue);
      me.formData.disease_investigated = investigatedValue;

      const notificationEps = me.record?.eps_notification ? "1" : "2";
      const notification = me.optionsNotification.find(
        (item) => item.id === notificationEps
      );
      me.onSelectNotification(notification);
      me.formData.eps_notification = notification;
      me.formData.research_observations = me.record?.research_observations;
      me.file1 = me.record?.file?.investigation_file ? me.record?.file?.investigation_file : null;
      me.file2 = me.record?.file?.furel_file ? me.record?.file?.furel_file : null;
      me.file3 = me.record?.file?.ministry_notification_file ? me.record?.file?.ministry_notification_file : null;
      me.file4 = me.record?.file?.eps_notification_file ? me.record?.file?.eps_notification_file : null;
    }
  },
  mounted() {
    const me = this;
    if (me.record) me.fillData();
  }
};
</script>

<style lang="css">
.card-diagnostic .card-header {
  background: #f5f5f5 !important;
}
</style>
